import React, { useState } from "react";
import styled from "./Icons.module.css";
const Icons = function (props) {
  const [chestOpen, setChestOpen] = useState(false);

  const setChestHandler = function () {
    setChestOpen(true);
    props.onMessage();
  };

  return (
    <React.Fragment>
      <div className={styled.container}>
        {props.nameValid && (
          <button className={styled.icon} onClick={setChestHandler}>
            <img
              src="https://img.icons8.com/external-icongeek26-linear-colour-icongeek26/64/000000/external-key-retro-80s-icongeek26-linear-colour-icongeek26.png"
              alt="Key"
            />
          </button>
        )}
        {chestOpen || (
          <button className={styled.icon}>
            <img
              src="https://img.icons8.com/external-justicon-flat-justicon/64/000000/external-treasure-pirates-justicon-flat-justicon-1.png"
              alt="Chest"
            />
          </button>
        )}

        {chestOpen && (
          <button className={styled.icon}>
            <img
              src="https://img.icons8.com/external-justicon-flat-justicon/64/000000/external-treasure-pirates-justicon-flat-justicon.png"
              alt="OpenChest"
            />
          </button>
        )}
      </div>
    </React.Fragment>
  );
};

export default Icons;
